import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ModalModule } from 'ngx-bootstrap/modal';

import { AvatarsModule } from '®shared/avatars';
import { TrapFocusModule } from '®shared/trap-focus';
import { UserModule } from '®shared/user';

import { ReadingListMetadataModule } from '../metadata';

import { ListOwnersEditorModalComponent } from './list-owners-editor-modal.component';
import { ListOwnersEditorComponent } from './list-owners-editor.component';
import { ListOwnersEditorEffects } from './list-owners-editor.effects';
import { listOwnersReducer } from './list-owners.reducer';
import {
  STATE_FEATURE_LIST_OWNERS,
  getInitialListOwnersState,
} from './list-owners.state';
import { UserSearchFieldComponent } from './user-search-field.component';
import { UserSearchEffects } from './user-search.effects';

@NgModule({
  imports: [
    AvatarsModule,
    CommonModule,
    EffectsModule.forFeature([UserSearchEffects, ListOwnersEditorEffects]),
    MatAutocompleteModule,
    MatDividerModule,
    MatInputModule,
    ModalModule,
    ReactiveFormsModule,
    StoreModule.forFeature(STATE_FEATURE_LIST_OWNERS, listOwnersReducer, {
      initialState: getInitialListOwnersState,
    }),
    ReadingListMetadataModule,
    TrapFocusModule,
    UserModule,
  ],
  declarations: [
    UserSearchFieldComponent,
    ListOwnersEditorComponent,
    ListOwnersEditorModalComponent,
  ],
  exports: [
    UserSearchFieldComponent,
    ListOwnersEditorComponent,
    ListOwnersEditorModalComponent,
  ],
})
export class ListOwnersModule {}
